import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth uses an httpOnly cookie (set by the backend on login). The frontend and the
// /api routes are same-origin, so credentials are sent automatically and the token is
// never exposed to JS (mitigates XSS token theft).
const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { API };
export default api;
